import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Label,
  ErrorText,
  InputWrapper,
  StyledInput,
  CurrencySymbol,
} from './components/CurrencyInputStyles';
import { useCurrencyInput } from './hooks/useCurrencyInput';

const CurrencyInput = ({
  value,
  onChange,
  disabled,
  size,
  label,
  error,
  currencySymbol,
  placeholder,
  name,
  ...rest
}) => {
  const { displayValue, handleChange } = useCurrencyInput({
    value,
    onChange,
    name,
  });

  return (
    <Container>
      {label && <Label disabled={disabled}>{label}</Label>}
      <InputWrapper hasError={!!error} disabled={disabled}>
        <CurrencySymbol disabled={disabled} size={size}>
          {currencySymbol}
        </CurrencySymbol>
        <StyledInput
          type="text"
          value={displayValue}
          onChange={handleChange}
          disabled={disabled}
          size={size}
          placeholder={placeholder}
          {...rest}
        />
      </InputWrapper>
      {error && <ErrorText>{error}</ErrorText>}
    </Container>
  );
};

CurrencyInput.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  label: PropTypes.string,
  error: PropTypes.string,
  currencySymbol: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
};

CurrencyInput.defaultProps = {
  value: 0,
  onChange: undefined,
  disabled: false,
  size: 'sm',
  label: undefined,
  error: undefined,
  currencySymbol: 'R$',
  placeholder: '0,00',
  name: undefined,
};

export default CurrencyInput;



// WEBPACK FOOTER //
// ./src/design-system/atoms/CurrencyInput/CurrencyInput.jsx